import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { Environment } from './environment.provider';
import appVersion from '../app-version.json';

export const withDevToolsStub: typeof withDevtools = () => (store) => store;

export const environment: Environment = {
    production: true,
    appVersion,
    storeWithDevTools: withDevToolsStub
};
